export default "__VITE_ASSET__Dr9wdpx4__"